import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29fc5a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-5 offset-md-5" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "bi bi-check-circle-fill text-success fs-2" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "lp-page"
}
const _hoisted_9 = {
  class: "lp-breadcrumb",
  "aria-label": "breadcrumb"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-house-door" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right lp-breadcrumb__sep" }, null, -1))
const _hoisted_12 = { class: "lp-breadcrumb__current" }
const _hoisted_13 = { class: "lp-layout" }
const _hoisted_14 = { class: "lp-layout__content" }
const _hoisted_15 = { class: "lp-heading" }
const _hoisted_16 = { class: "lp-layout__aside" }

import { computed, ref, onMounted, onBeforeUnmount, watch, nextTick } from "vue";

import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import AchivementModal from "@/components/achivements/modal.vue";
import PathwayBadges from "@/components/PathwayBadges.vue";
import Loader from "@/components/LoaderLogoHC.vue";
import PathwayHeader from "@/modern/components/training/learningPaths/view/PathwayHeader.vue";
import SectionList from "@/modern/components/training/learningPaths/view/SectionList.vue";
import SectionsProgressCard from "@/modern/components/training/learningPaths/view/SectionsProgressCard.vue";
import NextChallengeCard from "@/modern/components/training/learningPaths/view/NextChallengeCard.vue";
import {
  ISection,
  IResources,
  hasAccess,
  resourceKind,
  useLearningPathI18n,
} from "@/modern/components/training/learningPaths/view/learningPath";
import "@/modern/styles/lp.scss";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const store = useStore();

// Refs
const achivementModal = ref<InstanceType<typeof AchivementModal>>();
const pathway = computed(() => store.getters.getCurrentPathway);
const user = computed(() => store.getters.currentUser);

const { t, lang: currentLanguage, tl } = useLearningPathI18n();

// Methods
const shareOnLinkedin = (pathway_id: string, user_id: string) => {
  // shareContent with this URL: https://share.hackingclub.com/achievement/pathway/1/user/2
  const url = `${process.env.VUE_APP_SHARE_URL}achievement/pathway/${pathway_id}/user/${user_id}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
  window.open(linkedinUrl, "_blank");
};

const explode = () => {
  achivementModal.value?.open();
};

const sections = ref<ISection[]>([])
const loading = ref(true);
const openSectionIds = ref<number[]>([]);

const entries = computed(() =>
  sections.value.flatMap(section => section.resources.map(resource => ({ section, resource })))
);

// Primeiro recurso pendente que o usuário consegue abrir; se tudo pendente estiver bloqueado, o primeiro bloqueado
const currentEntry = computed(() => {
  const pending = entries.value.filter(entry => !entry.resource.completed);
  return pending.find(entry => hasAccess(entry.resource)) ?? pending[0] ?? null;
});

const nextPractice = computed<IResources | null>(() =>
  entries.value.find(({ resource }) =>
    !resource.completed && hasAccess(resource) && resourceKind(resource) !== 'lesson'
  )?.resource ?? null
);

const toggleSection = (sectionId: number) => {
  openSectionIds.value = openSectionIds.value.includes(sectionId)
    ? openSectionIds.value.filter(id => id !== sectionId)
    : [...openSectionIds.value, sectionId];
};

const focusSection = async (sectionId: number) => {
  if (!openSectionIds.value.includes(sectionId)) {
    openSectionIds.value = [...openSectionIds.value, sectionId];
  }
  await nextTick();
  document.getElementById(`lp-section-${sectionId}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const fetchSections = async () => {
  const { data } = await ApiService.get(`/pathways/${props.id}/sections`);
  sections.value = data.data;
};

// Os recursos abrem em outra aba; ao voltar, atualiza o progresso
const refreshOnReturn = () => {
  if (document.visibilityState !== 'visible' || loading.value) return;
  fetchSections();
  store.dispatch(Actions.GET_PATHWAY, props.id);
};

// Watch
watch(
  pathway,
  (val) => {
    if (val.acknowledge_required) {
      explode();
      ApiService.get(`/pathways/${pathway.value.id}/ack`).then((response) => {
        console.log(response);
      });
    }
  },
  { deep: true }
);

// Lifecycle
onMounted(async () => {
  setCurrentPageTitle("Machines List");
  await fetchSections();
  const initial = currentEntry.value?.section ?? sections.value[0];
  if (initial) openSectionIds.value = [initial.id];
  loading.value = false;
  document.addEventListener('visibilitychange', refreshOnReturn);
});

onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', refreshOnReturn);
});

// Initialize
store.dispatch(Actions.GET_PATHWAY, props.id);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AchivementModal, {
        ref_key: "achivementModal",
        ref: achivementModal
      }, {
        header: _withCtx(() => [
          _createElementVNode("h3", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.achivement.learning_path.title`)) + " ", 1),
            _hoisted_3
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.achivement.learning_path.message_1`, { user: _unref(user).nick || 'No nick' })) + " " + _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.achivement.learning_path.message_2`, { learning_path: _unref(pathway).name })), 1),
          _createVNode(PathwayBadges, {
            pathway: _unref(pathway),
            "extra-classes": "mt-5 mb-5 d-flex item-center justify-content-center text-center align-center"
          }, null, 8, ["pathway"]),
          _createElementVNode("img", {
            src: _unref(pathway).image,
            class: "avatar-img img-fluid",
            alt: "image"
          }, null, 8, _hoisted_4),
          _hoisted_5
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", _hoisted_6, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.close`)), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (shareOnLinkedin(_unref(pathway).id, _unref(user).id))),
            type: "button",
            class: "btn btn-purple"
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.share_on_linkedin`)), 1)
          ])
        ]),
        _: 1
      }, 512)
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("nav", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "lp-breadcrumb__home"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: { name: 'learning-paths' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(tl)('breadcrumb_root')), 1)
              ]),
              _: 1
            }),
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(pathway).name), 1)
          ]),
          _createVNode(PathwayHeader, {
            pathway: _unref(pathway),
            "pathway-id": __props.id,
            "current-resource": _unref(currentEntry)?.resource ?? null,
            onShareLinkedin: explode
          }, null, 8, ["pathway", "pathway-id", "current-resource"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_unref(tl)('content_title')), 1),
              _createVNode(SectionList, {
                sections: sections.value,
                "pathway-id": __props.id,
                "open-section-ids": openSectionIds.value,
                "current-resource-id": _unref(currentEntry)?.resource.id ?? null,
                onToggle: toggleSection
              }, null, 8, ["sections", "pathway-id", "open-section-ids", "current-resource-id"])
            ]),
            _createElementVNode("aside", _hoisted_16, [
              _createVNode(SectionsProgressCard, {
                sections: sections.value,
                "current-section-id": _unref(currentEntry)?.section.id ?? null,
                onSelect: focusSection
              }, null, 8, ["sections", "current-section-id"]),
              (_unref(nextPractice))
                ? (_openBlock(), _createBlock(NextChallengeCard, {
                    key: 0,
                    resource: _unref(nextPractice),
                    "pathway-id": __props.id
                  }, null, 8, ["resource", "pathway-id"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ], 64))
}
}

})